import React, { useState } from "react";
import { Row } from "react-bootstrap";
import FeatherIcon from "feather-icons-react";
import SaleOrdersSingleShippingAddress from "./FormShipping/SaleOrdersSingleShippingAddress";
import FormSaleOrdersMultipleShippingAddress from "./FormShipping/FormSaleOrdersMultipleShippingAddress";
import SaleOrdersShippingMethod from "./FormShipping/SaleOrdersShippingMethod";
import { toast } from "react-toastify";

export default function SaleOrdersFormShippingView(props) {
  const { customer, formik, sAddress, addresses, order, setOrder, getAddresses, setSAddress, currency } = props;
  const [selectedShippingAddress, setSelectedShippingAddress] = useState(0);

  const selectedShippingAddressHandler = (value) => {
    setSelectedShippingAddress(Number(value));
  };

  const goStep3 = () => {
    window.scrollTo(0, 0)
    const shippingType = order.shippingType
    if (!shippingType) {
      toast.error("Enter Shipping Method")
    } else if ((!order.shippingCost || parseFloat(order.shippingCost) === 0.0) && (shippingType !== "Regular Shipping" && shippingType !== "2 Day Shipping" && shippingType !== "Next Day")) {
      toast.error("Enter Shipping Cost")
    } else {
      props.setGoSteps(3)

    }
  }
  return (
    <React.Fragment>
      <div
        id="purschase-order-shipping"
        className="app-card">
        <div
          className={`st-form st-form-with-label-left d-flex flex-wrap align-items-center ${formik?.touched?.active && formik?.errors?.active
            ? "has-msg msg-error" : ""
            }`}
        >
          <div className="media-body st-form-input-container align-left">
            <input
              type="radio"
              className="custom-radio"
              // {...formik.getFieldProps('active')}
              value={0}
              checked={0 === selectedShippingAddress}
              onChange={(e) => {
                // formik.setFieldValue("active", e.target.value)
                selectedShippingAddressHandler(e.target.value);
              }}
            />{" "}
            {` Shipping Address Specified`}
            <input
              type="radio"
              className="custom-radio ms-3"
              // {...formik.getFieldProps('active')}
              value={1}
              checked={1 === selectedShippingAddress}
              onChange={(e) => {
                // formik.setFieldValue("active", e.target.value)
                selectedShippingAddressHandler(e.target.value);
              }}
            />
            {` Select the Shipping Address`}
          </div>
        </div>
        <div className="st-form flex-wrap mb-0">
          <div className="app-card-content st-border-light align-items-center">
            <Row style={{ width: "80%" }}>
              <div className="app-card" style={{ width: "50%" }}>
                {selectedShippingAddress === 0 ? (
                  <SaleOrdersSingleShippingAddress
                    formik={formik}
                    customer={customer}
                    sAddress={sAddress} />
                ) : (
                  <FormSaleOrdersMultipleShippingAddress
                    formik={formik}
                    getAddresses={getAddresses}
                    customer={customer}
                    sAddress={sAddress}
                    setSAddress={setSAddress}
                    addresses={addresses} />
                )}
              </div>
              <SaleOrdersShippingMethod
                formik={formik}
                order={order}
                getAddresses={getAddresses}
                setOrder={setOrder}
                currency={currency}
              />
            </Row>
          </div>
        </div>
        <div className="app-card-content bg-white  d-flex align-items-center justify-content-end mt-3">
          <button
            type="submit"
            className={`st-btn no-min-width st-btn-gray st-btn-sm  no-min-width d-flex align-items-center justify-content-center me-2`}
            onClick={() => { props.setGoSteps(1) }}
          >
            <FeatherIcon
              icon="arrow-left"
              size="14"
              className="icon me-1"
            />

            <span>Back</span>
          </button>
          <button
            // type="submit"
            // className={`st-btn st-btn-primary d-flex align-items-center justify-content-center ${(createButtonDisable || Object.keys(formik.errors).length) ? "disabled" : ""}`}
            className={`st-btn no-min-width st-btn-primary st-btn-sm  no-min-width d-flex align-items-center justify-content-center`}
            onClick={() =>
              goStep3()
            }
          >
            <span>Next</span>
            <FeatherIcon
              icon="arrow-right"
              size="14"
              className="icon ms-1"
            />
          </button>
        </div>
      </div>
    </React.Fragment>
  );
}
